
import { computed, ref, useContext, watch } from '@nuxtjs/composition-api';
import useUtilities from '@/composable/useUtilities';
import useDiscounts from '~/composable/discounts/useDiscounts';
import useTlmCart from '~/composable/useTlmCart';
import useTracking from '~/composable/tracking/useTracking';

export default {
  name: 'KeepSubscriptionDiscount',
  props: {
    chosenVariantSku: {
      type: String,
      default: null
    },
    masterProductSlug: {
      type: String,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    },
    keepSubscriptionInfoModal: {
      type: Boolean,
      default: false
    },
    selectedIndex: {
      type: Number,
      default: null
    }
  },
  setup(props, { emit }) {
    const { app } = useContext()
    const { formatPrice, getSubscriptionName } = useUtilities()
    const chosenSku = computed(() => props.chosenVariantSku)
    const loginFormValid = ref(false)
    const currentSubscriptionPriceMatrix = ref(null)
    const showCurrentSubscription = ref(false)
    const { loadOrCreateCart, cartID, isPayGSubscription } = useTlmCart(app);
    const {
      sku,
      discountCalculationCompleted,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      loading,
      cartID: discountedCartID,
      password,
      resetState,
      calculateDiscountForKeepingSubscription,
      productKey,
      userName,
      notEligibleError,
      inputError,
      errorState,
      mbbCustomerError,
      noDiscountError,
      mcSubUserError,
      discountResponse,
      getLatestDiscountCalculated
    } = useDiscounts(app)
    const { track } = useTracking()
    const showLoginFields = ref(Object.keys(getLatestDiscountCalculated).length === 0)
    // prepare data
    loadOrCreateCart();
    sku.value = props.chosenVariantSku;
    productKey.value = props.masterProductSlug;
    discountedCartID.value = cartID.value;
    watch(discountCalculationCompleted, (discountCalcCompleted) => {
      if (discountCalcCompleted) {
        emit('discount-calculated', { calculationResponse: discountResponse });
      }
    });
    const changeNumber = () => {
      resetState();
      sku.value = props.chosenVariantSku;
      productKey.value = props.masterProductSlug;
      discountedCartID.value = cartID.value;
      showLoginFields.value = true;
    }
    const calculate = async () => {
      await calculateDiscountForKeepingSubscription()
      showLoginFields.value = !discountCalculationCompleted.value
    }
    if (Object.keys(getLatestDiscountCalculated.value).length !== 0 && getLatestDiscountCalculated.value.discountCalculatedForSku !== props.chosenVariantSku) {
      changeNumber()
    }
    const scrollToBottom = () => {
      setTimeout(() => { // wait for animation
        const scrollContainer = document.querySelector('.custom-scrollbar');
        const options = scrollContainer?.querySelectorAll('.v-badge');
        const element = Array.from(options)[props.selectedIndex]
        scrollContainer.scrollTo({ top: element.offsetTop, behavior: 'smooth' });
      }, 300)
    }
    const trackData = (interactionLabel) => {
      track('keepSubscription', { interactionLabel })
    }
    const continueWithKeepSubscription = () => {
      trackData('Fortsæt')
      emit('discount-calculated', { calculationResponse: getLatestDiscountCalculated });
      emit('currentSubscriptionChosen', { userName: userName.value })
    }
    return {
      continueWithKeepSubscription,
      isPayGSubscription,
      getSubscriptionName,
      trackData,
      scrollToBottom,
      mcSubUserError,
      mbbCustomerError,
      chosenSku,
      errorState,
      calculate,
      showLoginFields,
      formatPrice,
      showCurrentSubscription,
      currentSubscriptionPriceMatrix,
      loginFormValid,
      userName,
      discountCalculationCompleted,
      password,
      calculateDiscountForKeepingSubscription,
      notEligibleError,
      inputError,
      noDiscountError,
      discountResponse,
      changeNumber,
      getLatestDiscountCalculated
    }
  }
}
